import { render, staticRenderFns } from "./basic-information.vue?vue&type=template&id=11a0c2c0&scoped=true"
import script from "./basic-information.vue?vue&type=script&lang=js"
export * from "./basic-information.vue?vue&type=script&lang=js"
import style0 from "./basic-information.vue?vue&type=style&index=0&id=11a0c2c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0c2c0",
  null
  
)

export default component.exports